<template>
	<div>
		<el-drawer :visible.sync="drawer_model" :size="drawer_size" :title="drawer_title" @opened="drawer_onshow"
			@close="drawer_onhide">
			<template #default>
				<div class="full"
					style="position: relative;width: 100%;height: 90%;padding: 10px;box-sizing: border-box;"
					v-loading="loading">
					<div class="flex"
						style="position: relative;width: 100%;height: 50%;flex-direction: column;box-sizing: border-box;">
						<template v-if="row">
							<div style="box-sizing: border-box;margin-bottom: 10px;">
								<el-tag type="success" v-if="row.signfor==5">已核对</el-tag>
								<el-tag type="danger" v-else>未核对</el-tag>
								<el-tag effect="dark" type="danger" v-if="row.voucherurgent==1"
									style="margin-left: 10px;" size="mini">急</el-tag>
							</div>
						</template>
						<div style="position: relative;width: 100%;flex: 1;box-sizing: border-box;">
							<div class="full">
								<vxe-grid ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions"
									@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
							</div>
						</div>
					</div>
					<div class="flex" style="position: relative;height: 50%;width: 100%;">
						<div class="img_block">
							<el-divider content-position="center">凭证</el-divider>
							<div class="flex" style="flex-wrap: wrap;">
								<div v-for="(item,index) in file_path"
									style="width: 100%;height: 140px;margin: 6px;position: relative;" :key="index">
									<div
										style="width: 100%;position: absolute;bottom: 0;text-align: center;font-weight: bold;font-size: 14px;">
										{{item.billCode}}
									</div>
									<div class="full flex" style="height: 120px;">
										<upload ref="voucherfile" :previewImgModal="true" :autopreviewImg="true"
											:previewImgIndex="index" :disabled="true" :formCreateInject="true"
											:value="item.file" @imgrotated="imgrotated" />
										<!-- 										<el-image class="full" :src="item.path" :preview-src-list="file_path.map(file=>file.path)"></el-image>		
										<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
											<el-tag effect="dark" type="success" v-if="item.voucherstatus==2">签章</el-tag>
											<el-tag effect="dark" type="success" v-if="item.voucherstatus==3">已核对</el-tag>
											<el-tag effect="dark" type="success" v-if="item.voucherstatus==4">已完成</el-tag>
											<el-tag effect="dark" type="danger" v-if="item.voucherstatus==1">未签章</el-tag>
										</div>
										<el-image class="full" style="opacity: 0;" :src="item.path" :preview-src-list="file_path.map(file=>file.path)"></el-image>	 -->
									</div>


								</div>
							</div>
						</div>
						<div class="img_block">
							<el-divider content-position="center">回单</el-divider>
							<div class="flex" style="flex-wrap: wrap;">
								<div v-for="(item,index) in receipt_path"
									style="width: 100%;height: 140px;margin: 6px;position: relative;" :key="index">
									<div
										style="width: 100%;position: absolute;bottom: 0;text-align: center;font-weight: bold;font-size: 14px;">
										{{item.billCode}}
									</div>
									<div class="full flex" style="height: 120px;">
										<upload :disabled="true" :formCreateInject="true" :value="item.path" />
									</div>
									<!-- 									<div class="full" style="height: 120px;" @click="receiptShow(item.path)">
										<img class="full" :src="require('@_system/icon/pdf.png')" />
									</div> -->

								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="flex" style="justify-content: space-around;" v-if="reconciliationtype=='batch'">
					<vxe-button status="primary" style="margin: 0px;width: 48%;" size="medium" @click="preorder">上一单</vxe-button>
					<vxe-button status="primary" style="margin: 0px;width: 48%;" size="medium" @click="nextorder">下一单</vxe-button>
				</div>
				<div style="position: absolute;bottom: 20px;right: 10px;">
					<vxe-button status="" content="刷新" @click="reflash"></vxe-button>
					<vxe-button status="primary" content="核对签收" @click="signforChnage"></vxe-button>
					<vxe-button status="warning" content="加急/撤销" @click="urgent"></vxe-button>
					<vxe-button status="danger" content="驳回" @click="reject"></vxe-button>
				</div>
			</template>

		</el-drawer>
		<receipt v-if="receiptparam" ref="receipt" :param="receiptparam" />
	</div>
</template>
<style scoped>
	.img_block {
		position: relative;
		margin-top: 20px;
		width: 50%;
		height: 300px;
		display: inline-block;
		box-sizing: border-box;
		padding: 10px;
		box-sizing: border-box;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import drawerMixins from '@_system/components/base/mixins/drawer/drawer.js'
	import receipt from '@/views/main/paymentout/paymentapplication/lib/receipt/index.vue'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		mixins: [listMixins, drawerMixins],
		props: {
			rows:{
				default:()=>{
					return []
				}
			},
			currentrow: {
				default: () => {
					return null
				}
			},
			reconciliationtype: {
				default: () => {
					return 'single'
				}
			}
		},
		data() {
			return {
				loading: false,
				list_autorender: false,
				drawer_title: '对账',
				drawer_size: '50%',
				drawer_height: 800,
				list_footerField: [{
					field: 'size',
					toFixed: 0
				}, {
					field: 'sum',
					toFixed: 2
				}],
				orderdata: [],
				columns: [],
				toolbarButton: [],
				file_path: [],
				receipt_path: [],
				receiptparam: null,
				row: null,
				batchIndex:0
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			nextorder(){
				this.batchIndex++
				if(this.batchIndex > (this.rows.length - 1)){
					this.$message.error('当前是最后一单')
					this.batchIndex = this.rows.length - 1
					return
				}
				this.drawer_init()
			},
			preorder(){
				this.batchIndex--
				if(this.batchIndex < 0){
					this.$message.error('当前是第一单')
					this.batchIndex = 0
					return
				}
				this.drawer_init()
			},
			imgrotated(e) {
				try {
					let degree = this.normalizeAngle(e.degree)
					let uid = this.file_path[e.previewImgIndex].file[e.index].uid
					console.log(uid,degree,this.row.id)
					this.$api.purchasestockbill.updateImgAttributes({
						id:this.row.id,
						degree:degree,
						uid:uid,
						field:'file_path',
						previewImgIndex:e.previewImgIndex
					})
				} catch (error) {
					console.log(error)
				}

			},
			normalizeAngle(angle) {
				angle = angle % 360;
				if (angle < 0) {
					angle += 360;
				}
				return angle;
			},
			drawer_init() {
				
				if(this.rows.length){
					this.row = this.rows[this.batchIndex]
				}else{
					this.row = this.currentrow
				}
				console.log(this.reconciliationtype)
				this.drawer_title = '对账【'+this.row.stockCode+'】' 
				this.file_path = []
				this.receipt_path = []
				let list_columns = [{
					field: 'stockCode',
					title: '入库单编码',
				}, {
					field: 'skuCode',
					title: '商品编码',
				}, {
					field: 'goodsName',
					title: '商品名称',
				}, {
					field: 'skuName',
					title: '规格'
				}, {
					field: 'size',
					title: '数量'
				}, {
					field: 'price',
					title: '单价'
				}, {
					field: 'unitName',
					title: '单位'
				}, {
					field: 'sum',
					title: '小计'
				}, {
					field: 'status',
					title: '状态',
					slots: {
						default: ({
							row
						}) => {
							if (row.status == 0) {
								return '未到货'
							}
							if (row.status == 1) {
								return '部分入库'
							}
							if (row.status == 2) {
								return '完成'
							}
						},
					}
				}, {
					field: 'ischeck',
					title: '核对',
					slots: {
						default: ({
							row
						}) => {
							return <el-switch v-model={row.ischeck} active-value={1} inactive-value={0} onChange={()=>{this.icheckchange(row)}}  ></el-switch>
						},
					}
				}, {
					title: '操作',
					fixed: "right",
					align: 'center',
					slots: {
						default: ({
							row
						}) => {
							return <el-button type = "text" size = "mini" onClick = {() => {this.receiptDownload(row)}} > 回单下载 </el-button>
						},
					}
				}]
				let list_toolbarButton = [{
					code: 'export',
					name: '导出',
					status: "success"
				}]
				this.columns = list_columns
				this.toolbarButton = list_toolbarButton
				this.list_init()
				this.$nextTick(() => {
					this.reflash()
				})

			},
			icheckchange(row){
				this.$api.purchasestockbill.updatedetail({
					stockDetailID:row.stockDetailID,
					ischeck: row.ischeck
				})
			},
			drawer_onhide() {
				this.batchIndex = 0
				this.file_path = []
				this.receipt_path = []
				this.$refs.voucherfile.forEach((item) => {
					item.clear()
				})
				this.$emit('drawerhide')
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = '100%'
				gridOptions.columns = this.columns
				gridOptions.toolbarConfig.buttons = this.toolbarButton
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.toolbarConfig = null
				gridOptions.formConfig = false
				gridOptions.cellStyle = this.cellStyle
				gridOptions.scrollY = {
					enabled: false
				}
			},
			reflash() {
				//this.$refs.orderdetail.commitProxy('query')
				this.loading = true
				this.$api.purchasestockbill.list({
					stockCode: this.row.stockCode,
					searchvague: 0
				}).then((res) => {
					this.row = res.list[0]
					//console.log(this.row,123123)
					for (let i in this.row) {
						if(this.reconciliationtype=='single'){
							this.currentrow[i] = this.row[i]
						}else{
							let obj = this.rows.find((item)=>{
								return item.id == this.row.id
							})
							if(obj){
								obj[i] = this.row[i]
							}
						}
						
					}
					this.$refs.orderdetail.commitProxy('query')
					this.loading = false
				})

			},
			reject() {
				this.$prompt('请填写驳回原因', '驳回', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputErrorMessage: '原因不能为空'
				}).then(({
					value
				}) => {
					this.$api.purchasestockbill.update(this.row.id, {
						reject: 1,
						rejectcontent: value
					}).then(() => {
						this.$message.success('操作成功')
					})
				}).catch(() => {

				})
			},
			signforChnage() {
				this.$api.purchasestockbill.update(this.row.id, {
					signfor: 5
				}).then(() => {
					this.reflash()
				})
			},
			urgent() {
				this.$api.purchasestockbill.update(this.row.id, {
					voucherurgent: 1
				}).then(() => {
					this.reflash()
				})
			},
			receiptDownload(row) {
				this.receiptparam = {
					code: row.applicationcode
				}
				this.$nextTick(() => {
					this.$refs.receipt.modalShow()
				})
			},
			receiptShow(path) {
				window.open(path, '_blank')
			},
			list() {
				this.file_path = []
				this.receipt_path = []
				return new Promise((resolve) => {
					this.$api.purchasestockbill.getDetail({
						id: this.row.id
					}).then((res) => {
						this.sourcedata = res
						let datagroup = this.$Lodash.groupBy(res, 'billCode')
						let purchasecode = this.$Lodash.keys(datagroup)
						purchasecode.forEach((item) => {
							if (datagroup[item][0]['hasreceipt']) {
								this.receipt_path.push({
									hasreceipt: datagroup[item][0]['hasreceipt'],
									billCode: item,
									path: [{
										name: item + '.pdf',
										uid: Math.random(),
										url: 'https://wz-nazhi.com/api/public/download/nbcb/receipt/' +
											item + '.pdf',
										path: 'https://wz-nazhi.com/api/public/download/nbcb/receipt/' +
											item + '.pdf'
									}]
								})
							}
						})

						for (let i in datagroup) {
							if (datagroup[i][0].file_path) {
								this.file_path.push({
									billCode: datagroup[i][0].billCode,
									file: datagroup[i][0].file_path,
									voucherstatus: datagroup[i][0].voucherstatus
								})
								// datagroup[i][0].file_path.forEach((item)=>{
								// 	this.file_path.push({
								// 		billCode:datagroup[i][0].billCode,
								// 		file:[item],
								// 		voucherstatus:datagroup[i][0].voucherstatus
								// 	})
								// })
							}
						}
						// console.log(datagroup)
						//console.log(this.file_path)
						resolve({
							list: res
						})
					})
				})
			},
			submit() {
				this.$refs.orderdetail.remove(this.row)
			},
			cellStyle({
				row,
				column
			}) {
				if (column.field == 'status') {
					if (row.status == 0) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.status == 1) {
						return {
							color: '#409EFF'
						}
					}
					if (row.status == 2) {
						return {
							color: '#67C23A'
						}
					}
				}

			},
		},
		components: {
			receipt,
			upload
		}
	}
</script>